import { toLower, kebabCase } from 'lodash/string'

import i18n from 'i18next'

export const titleToSlug = (title: string) => toLower(kebabCase(i18n.t(title)))
